import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { SettingsManagementComponent } from './components/settings-management/settings-management.component';

const routes: Routes = [
  { path: 'settings-management', component: SettingsManagementComponent},
  { path: '**', redirectTo: 'settings-management' },
]


@NgModule({
  declarations: [
    SettingsManagementComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ]
})
export class SettingsManagementModule { }
